/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'ai-mate.chat-error-banner.description': 'Keskusteluhistoriasi tallennetaan enintään 30 päivän ajan.',
  'ai-mate.chat-error-banner.title': 'Aloita uusi keskustelu',
  'ai-mate.chat-error.description': 'Yritä <btn>ladata keskustelu uudelleen</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Olet saavuttanut pyyntöjen enimmäismäärän. Yritä myöhemmin uudelleen.',
  'ai-mate.chat-error.rate-limited-title': 'Liian monta pyyntöä',
  'ai-mate.chat-error.rovo-inactive-description':
    'Näyttää siltä, että Rovo ei ole käytössä sivustollasi. <link>Rovon määritys</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo ei ole käytössä',
  'ai-mate.chat-error.title': 'Emme ole varmoja siitä, mikä meni vikaan',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Kysy AI:lta tästä',
  'highlight-actions.rovo-chat-explain-option.text': 'Selitä',
  'highlight-actions.rovo-chat-explain-prompt': 'Selitä tämä: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chat-suositukset',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Avaa chatti',
  'highlight-actions.rovo-chat-summarize-option.text': 'Tee yhteenveto',
  'highlight-actions.rovo-chat-summarize-prompt': 'Luo yhteenveto tästä: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Vieritä vasemmalle',
  'horizontal-scroll-container.scroll-right': 'Vieritä oikealle',
};
